export default function PHP_DataTypes() {
  return (
    <div>
      <h1>PHP_DataTypes</h1>
    </div>
  );
}
